<template>
    <div>
        <h3>Tenants Info</h3>

        <div class="md-layout md-alignment-space-between margin_bottom">
            <div class="md-alignment-top-right">
                <p>Provide further info for each tenant (if the main contact is the same as the designated FM contact leave the latter blank)</p>
            </div>
            <div class="md-layout-item md-alignment-top-right md-layout">
                <md-button @click="addTenant" title="Add Tenant" class="md-icon-button md-primary">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </div>

        <div class="md-layout md-gutter">

            <div class="md-layout-item md-size-15 md-medium-size-50 md-small-size-50">
                <div class="md-layout">
                   <tenants-logos class="md-layout-item md-size-100" :files="files"></tenants-logos>
                </div>
            </div>


           <tenants-table :files="files" :showChosenSwitch="false"  ref="tenantsTable" :tenantsDetails="tenantsDetails" class="md-layout-item md-size-85"></tenants-table>

        </div>



    </div>
</template>

<script>
    import TenantsLogos from "./TenantsLogos.vue";
    import TenantsTable from "./TenantsTable.vue";
   

    export default {
        name: 'BuildingTenantsInfo',
        components: {   
            TenantsLogos,
            TenantsTable,
        },
        props: {
            tenantsDetails: Array,
            files: null,
        },
        methods: {
            async validateTable() {
                return await this.$refs.tenantsTable.validateTable();
            },
            addTenant() {
                this.$refs.tenantsTable.addTenant();
            }
        }
    }
</script>

<style lang="scss">
    /* No idea why this was missing, stole from inspecting https://vuematerial.io/components/button/
        Without it, md-icon-buttons were not round !!! WTF ???
    */

    .md-icon-button {
        width: 40px;
        min-width: 40px;
        height: 40px;
        margin: 0 6px;
    }

    .md-fab, .md-icon-button {
        border-radius: 50%;
        z-index: 6;
    }


    .actions-container {
        text-align: center;
    }
   
    .md-steppers-wrapper {
        overflow-y: visible !important;
    }

    /*.md-icon.md-icon-font.md-theme-default.error {
        color: red;
    }
    .md-icon.md-icon-font.md-theme-default.success {
        color: green;
    }
     */
</style>
